//process.env.NODE_ENV es automatica de react, y en yarn start, devuelve development
const BACKEND_API_URL = process.env.NODE_ENV === 'development' ? "http://localhost:3501/v1" : "https://backend.chaibar.ai/v1";


module.exports = {
    BACKEND_API_URL: BACKEND_API_URL,
}
